import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type User = {
  id: string;
  email: string;
  name: string | null;
  quota: number;
};

type AuthState = {
  user: User | null;
  token: string | null;
  setAuth: (user: User, token: string) => void;
  logout: () => void;
  updateQuota: (delta: number) => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,

      setAuth: (user, token) => set({ user, token }),

      logout: () => {
        set({ user: null, token: null });
        localStorage.removeItem('auth-storage');
      },

      updateQuota: (delta) =>
        set((state) => ({
          user: state.user ? { ...state.user, quota: state.user.quota + delta } : null,
        })),
    }),
    {
      name: 'auth-storage',
    }
  )
);
